<template>
  <f-field>
    <template v-slot:label>{{ $vt(component.title) }}</template>
    <template v-slot:content>
      <div class="vform17-item-list" :class="{ disabled: component.disabled }">
        <div class="item-input-section">
          <div class="f-input-container" :class="{ focus: focused }">
            <input v-model="newItem" @keyup.enter="addItem" @keyup.escape="clearInput" @focus="focused = true"
              @blur="focused = false" type="text" class="f-input" :placeholder="component.placeholder"
              ref="itemInput" />
            <div class="f-right">
              <div class="f-action">
                <f-button @click="addItem" :disabled="!newItem.trim()" :type="['primary', 'small']">
                  <f-icon icon="fa6-plus"></f-icon>
                  {{ $vt('Add') }}
                </f-button>
              </div>
            </div>
          </div>
        </div>

        <div class="items-list" v-if="items.length > 0">
          <div v-for="(item, index) in items" :key="index" class="items-list-item" @click="removeItem(item)">
            <span class="value ">{{ $vt(item) }}</span>
            <f-icon icon="fa6-times"></f-icon>
          </div>
        </div>

        <!-- <div v-else class="empty-state">
          {{ $vt('No items added') }}
        </div> -->
      </div>
    </template>
    <template v-slot:helper v-if="component.description">{{ $vt(component.description) }}</template>
  </f-field>
</template>

<script>
export default {
  name: 'Vform17ItemList',
  props: ['component', 'handler'],
  data() {
    return {
      newItem: '',
      items: [],
      focused: false
    };
  },
  mounted() {
    // Initialiser avec les items initiaux du component
    if (this.component.items && Array.isArray(this.component.items)) {
      this.items = [...this.component.items];
    }
  },
  watch: {
    'component.items': {
      handler(newItems) {
        if (newItems && Array.isArray(newItems)) {
          this.items = [...newItems];
        }
      },
      deep: true
    }
  },
  methods: {
    addItem() {
      const trimmedItem = this.newItem.trim();

      const index = this.items.findIndex(i => i === trimmedItem);

      if (index !== -1) {
        return;
      }

      if (trimmedItem) {
        this.items.push(trimmedItem);
        this.newItem = '';

        // Émettre l'événement via le handler
        if (this.handler && this.handler.action) {
          this.handler.action(this.component, 'add', [trimmedItem]);
        }

        // Remettre le focus sur l'input
        this.$nextTick(() => {
          if (this.$refs.itemInput) {
            this.$refs.itemInput.focus();
          }
        });
      }
    },
    removeItem(item) {
      // Trouver l'index de l'item dans le tableau
      const index = this.items.findIndex(i => i === item);

      if (index !== -1) {
        this.items.splice(index, 1);

        // Émettre l'événement via le handler
        if (this.handler && this.handler.action) {
          this.handler.action(this.component, 'delete', [item]);
        }
      }
    },
    clearInput() {
      this.newItem = '';
      if (this.$refs.itemInput) {
        this.$refs.itemInput.blur();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.vform17-item-list {
  width: 100%;

  &.disabled {
    opacity: 0.6;
    pointer-events: none;
  }
}

.item-input-section {
  margin-bottom: 10px;


}


.items-list {
  flex-wrap: wrap;
  gap: 10px;
  display: flex;


  .items-list-item {
    display: flex;
    align-items: center;
    gap: 10px;
    background: var(--white-a10);
    color: var(--white-a50);
    font-size: 14px;
    padding: 5px;
    border-radius: 4px;
    cursor: pointer;

    &:hover {
      background: var(--white-a25);
    }
  }
}

.empty-state {
  color: var(--text-muted, #6c757d);
  font-style: italic;
}
</style>
